export default __webpack_public_path__ + "static/media/mobile.fe9d0585.svg";